function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fansi-video_svg__cls-1{fill:#fff}.fansi-video_svg__cls-2{fill:#eae9ee}.fansi-video_svg__cls-3{fill:#796eaf}.fansi-video_svg__cls-4{fill:#6350bc}.fansi-video_svg__cls-5{fill:#bbe4e0}.fansi-video_svg__cls-6{fill:#f2b389}.fansi-video_svg__cls-7{fill:#9082c0}.fansi-video_svg__cls-8{fill:#e39fb7}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-1",
  d: "M-2450.71-8114.18h9446.2V2161.91h-9446.2z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-2",
  d: "M427.55 175.66l-282.51.06c-26.53 0-48.03 21.48-48.02 47.97l.13 637.71c0 26.49 21.51 47.96 48.04 47.95l282.51-.06c26.53 0 48.03-21.48 48.02-47.97l-.13-637.71c0-26.49-21.51-47.96-48.04-47.95z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-2",
  transform: "rotate(179.99 100.59 289.314)",
  d: "M88.76 258.05h23.65v62.54H88.76z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-1",
  transform: "rotate(179.99 106.74 289.324)",
  d: "M101.06 259.2h11.35v60.25h-11.35z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-5",
  d: "M101.07 320.58c-.3 0-.59-.12-.8-.33s-.33-.5-.33-.8V259.2c-.01-.62.49-1.13 1.12-1.13h11.35c.3 0 .59.12.8.33s.33.5.33.8v60.25c.01.62-.49 1.13-1.12 1.13h-11.35zm1.12-60.25v57.99h9.1v-57.99h-9.1zM452.78 175.65l-282.51.06c-26.53 0-48.03 21.48-48.02 47.97l.13 637.71c0 26.49 21.51 47.96 48.04 47.95l282.51-.06c26.53 0 48.03-21.48 48.02-47.97l-.13-637.71c0-26.49-21.51-47.96-48.04-47.95z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-1",
  transform: "rotate(179.99 311.263 537.237)",
  d: "M122.18 273.5h378.14v527.48H122.18z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-5",
  d: "M122.23 802.15c-.3 0-.59-.12-.8-.33s-.33-.5-.33-.8l-.1-527.48c0-.3.12-.59.33-.8s.5-.33.8-.33l378.14-.07c.62 0 1.13.51 1.13 1.13l.1 527.48c0 .62-.51 1.13-1.13 1.13l-378.14.08zm1.03-527.48l.1 525.21 375.88-.08-.1-525.21-375.88.07z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-5",
  d: "M169.93 910.48c-13.19 0-25.44-5.22-34.49-14.7-9.2-9.64-14.27-22.91-14.27-37.38l-.13-638.51c0-11.38 5.21-22.86 14.3-31.49 9.38-8.91 21.62-13.82 34.46-13.83l283.31-.06v1.13-1.13c25.97 0 48.76 21.16 48.76 45.3l.13 638.51c0 29.69-20.96 52.09-48.76 52.1l-283.31.06zm283.18-733.7l-283.31.06c-12.25 0-23.94 4.69-32.9 13.2-8.64 8.21-13.59 19.09-13.59 29.85l.13 638.51c0 13.88 4.85 26.6 13.65 35.82 8.62 9.03 20.29 14 32.86 14l283.31-.06c26.51 0 46.5-21.43 46.49-49.84l-.13-638.51c0-22.93-21.74-43.03-46.5-43.03z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-1",
  d: "M298.74 199.55c-.62 0-1.13-.51-1.13-1.13s.51-1.13 1.13-1.13l81.06-.02c.62 0 1.13.51 1.13 1.13s-.51 1.13-1.13 1.13l-81.06.02zM284.4 205.5c-1.89 0-3.67-.74-5.01-2.07-1.34-1.34-2.08-3.12-2.08-5.01s.74-3.67 2.08-5.01a7.05 7.05 0 015.02-2.08c3.91 0 7.09 3.18 7.1 7.08 0 3.91-3.18 7.09-7.09 7.09zm0-11.91c-1.29 0-2.5.5-3.42 1.41-.91.91-1.41 2.12-1.41 3.41s.5 2.5 1.41 3.41a4.81 4.81 0 003.42 1.41c2.66 0 4.83-2.16 4.83-4.83 0-2.66-2.17-4.82-4.83-4.82z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-6",
  d: "M512.2 776.66l8.66 21.41c2.92 6.74 2.62 14.3-.22 21.07-8.24 19.66 18.57 44.35 23.57 66.42 1.94 7.87 4.9 20.28 15.9 16.53 5.19-1.3 8.39-6.5 7.21-11.7l-7.61-33.57 16.64 1.62c16.7 1.05 34.1 27.78 48.85 34.83 14.76 7.06 18.34-7.21 18.34-7.21s18.72 21.96 28.06 11.5c3.65-3.96 3.61-10.07-.09-13.99l-91.23-96.33-13.95-27.96-54.14 17.38z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-3",
  d: "M566.34 759.28l10.09 20.22c-14.14 1.25-22.31 6.03-27.21 10.33-5.02 4.41-8.11 9.64-14.78 10.97-5.34 1.06-10.26-.91-13.58-2.74-2.89-7.14-5.77-14.27-8.66-21.41l54.14-17.38zM643.63 887.28c-.29 0-.58-.11-.8-.33l-20.19-20.26c-3.74-3.75-6.73-7.03-9.63-10.19-5.2-5.69-10.11-11.06-18.75-18.62-.47-.41-.52-1.13-.11-1.6.41-.47 1.13-.52 1.6-.11 8.74 7.64 13.69 13.06 18.93 18.8 2.88 3.15 5.86 6.41 9.56 10.12l20.19 20.26c.44.44.44 1.16 0 1.6-.22.22-.51.33-.8.33zM559.71 857.95c-.51 0-.97-.35-1.1-.87l-7.14-29.64c-.15-.61.23-1.22.83-1.36.61-.14 1.22.23 1.36.83l7.14 29.64a1.122 1.122 0 01-1.1 1.39z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-3",
  d: "M556.33 903.91c-1.58 0-3.06-.37-4.4-1.1-5.35-2.93-7.33-10.93-8.77-16.78l-.05-.2c-1.9-8.39-7.13-17.38-12.19-26.06-8.16-14.01-16.59-28.49-11.32-41.07 2.84-6.79 2.92-13.96.22-20.19l-9.13-22.56 56.23-18.05 14.3 28.68 91.12 96.21c4.1 4.33 4.15 11.15.1 15.53-1.89 2.11-4.27 3.19-7.06 3.19h-.13c-8.22-.09-17.84-9.58-21.28-13.29-.9 2.1-2.81 5.4-6.4 7.09-3.58 1.69-7.91 1.34-12.86-1.02-6.16-2.95-12.58-9.06-19.38-15.52-9.61-9.14-19.56-18.6-29.05-19.2l-15.12-1.47 7.26 32.04c1.3 5.76-2.3 11.61-8.03 13.05-1.41.48-2.77.73-4.06.73zM513.7 777.36l8.21 20.28c2.94 6.77 2.86 14.57-.22 21.94-4.83 11.53 2.95 24.9 11.19 39.05 5.14 8.83 10.46 17.97 12.43 26.68l.04.18c1.34 5.44 3.18 12.89 7.66 15.34 1.89 1.03 4.09 1.09 6.74.19 4.64-1.17 7.5-5.81 6.47-10.38l-7.95-35.1 18.2 1.77c10.28.65 20.52 10.39 30.43 19.81 6.67 6.34 12.96 12.33 18.8 15.12 4.3 2.06 7.98 2.4 10.92 1.02 4.44-2.09 5.82-7.43 5.84-7.49l.53-2.13 1.42 1.67c.12.14 11.9 13.83 20.87 13.93h.1c2.15 0 3.92-.8 5.38-2.45 3.25-3.52 3.21-8.99-.07-12.46l-91.35-96.45-13.59-27.24-52.06 16.71z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-8",
  d: "M577.97 779.5l-101.21.02-50.84-193.59-38.28-169.72 69.9-11.98c36.35-6.23 69.56 21.72 69.57 58.55l.02 123.13 50.84 193.59z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-7",
  d: "M455.41 799.64l-126.61.02-.03-168.09 126.61-.03.03 168.1z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-7",
  d: "M309.36 800.19l-126.61.02 63.47-168.62 126.61-.03-63.47 168.63z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-7",
  d: "M182.5 802.02a1.137 1.137 0 01-1.06-1.53l63.72-169.3c.22-.58.87-.88 1.46-.66.58.22.88.87.66 1.46l-63.14 167.77 124.3-.3 34.35-91.27c.22-.58.87-.88 1.46-.66.58.22.88.87.66 1.46l-34.63 92c-.17.44-.59.73-1.06.73l-126.72.31z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-4",
  d: "M455.39 655.18l-231.52 35.46 16.97-43.92 214.54-3.12.01 11.58z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-8",
  d: "M277.68 423.11l-3.1.2c-52.52 1.64-69.55 76.72-25.61 106.87l1.95 1.3-20 121.15h242.02l12.63-240.48-207.9 10.96z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M472.95 653.76h-18.93a1.129 1.129 0 110-2.26h17.85l10.21-194.43c.03-.62.53-1.11 1.19-1.07.62.03 1.1.57 1.07 1.19L474.07 652.7c-.03.6-.53 1.07-1.13 1.07z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-6",
  d: "M544.09 324.3l-40.08 34.09 9.9-27.65 10-8.83a13.52 13.52 0 0119.07 1.15l1.11 1.25z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-6",
  d: "M590.36 393.1l-33.27 45.89-69.34-15.38 7.42-55.79c2-15.01 9.32-28.77 20.6-38.73l6.9-6.09 67.69 70.1z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-2",
  d: "M446.72 267.17c-.07 0-.13 0-.2-.02-.61-.11-1.02-.7-.91-1.32l29.99-165.49c.11-.61.7-1.02 1.32-.91.61.11 1.02.7.91 1.32l-29.99 165.49c-.1.55-.58.93-1.11.93zM447.22 353.47c-2.36 0-4.6-.62-6.71-1.86-.99-.58-2.14-1.32-3.2-2.4-3.65-3.68-4.23-5.96-5.21-9.75l-.06-.23c-.16-.6.21-1.22.81-1.38.6-.15 1.22.21 1.38.81l.06.23c.94 3.65 1.41 5.48 4.62 8.72.88.89 1.88 1.53 2.74 2.04 4.53 2.68 9.73 1.91 15.86-2.35l196.06-133.1c.52-.35 1.22-.22 1.57.3.35.52.22 1.22-.3 1.57L458.79 349.16c-4.12 2.86-8 4.3-11.59 4.3z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-2",
  d: "M641.68 217.99c-21.62 0-56.8-13.48-91.79-35.68-39.59-25.11-69.26-55.78-73.84-76.32-1.19-5.33-.65-9.82 1.59-13.35 11.14-17.51 60.32-5.55 111.97 27.21 50.46 32.01 82.56 72.49 71.56 90.22-2.17 3.5-5.89 5.87-11.04 7.05-2.51.57-5.34.85-8.45.85zM497.94 86.95c-9.07 0-15.47 2.33-18.39 6.91-1.91 3-2.35 6.92-1.3 11.64 4.46 19.99 33.73 50.08 72.84 74.9 39.55 25.09 79.15 38.97 98.52 34.53 4.54-1.04 7.78-3.07 9.62-6.04 10.18-16.4-22.26-56.3-70.85-87.12-24.25-15.38-49.02-26.71-69.76-31.89-7.87-1.96-14.84-2.93-20.7-2.93zM539.62 90.95c-.2 0-.41-.05-.59-.17-.53-.33-.69-1.03-.37-1.56l11.76-18.99c.33-.53 1.03-.7 1.56-.37.53.33.69 1.03.37 1.56l-11.76 18.99c-.21.35-.58.54-.96.54z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-2",
  d: "M522.67 118.32c-.2 0-.41-.05-.59-.17-.53-.33-.69-1.03-.37-1.56l14.13-22.81c.33-.53 1.03-.7 1.56-.37.53.33.69 1.03.37 1.56l-14.13 22.81c-.21.35-.58.54-.96.54zM570.56 104.81c-.23 0-.47-.07-.67-.22-.5-.37-.6-1.08-.23-1.58l24.45-32.84c.37-.5 1.08-.61 1.58-.23.5.37.6 1.08.23 1.58l-24.45 32.84c-.22.3-.56.46-.91.46zM536.8 150.16c-.23 0-.47-.07-.67-.22-.5-.37-.6-1.08-.23-1.58l30.43-40.87c.37-.5 1.08-.61 1.58-.23.5.37.6 1.08.23 1.58l-30.43 40.87c-.22.3-.56.46-.91.46zM572.88 91.71a1.122 1.122 0 01-.9-1.8l12.19-16.37c.37-.5 1.08-.61 1.58-.23.5.37.61 1.08.23 1.58l-12.19 16.37c-.22.3-.56.46-.91.46zM587.59 423.95c-.33 0-.66-.15-.89-.43l-83.58-105.7c-.2-.25-.28-.56-.23-.87s.22-.59.48-.76l28.1-19.08c.49-.33 1.15-.23 1.52.23l95.97 120.26c.39.49.31 1.2-.18 1.59-.49.39-1.2.31-1.59-.18l-95.32-119.45-26.23 17.8 82.82 104.75c.39.49.3 1.2-.19 1.59-.21.16-.46.24-.7.24z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-6",
  d: "M569.56 327.62l-45.65 40.29-13.17-15.24 45.65-40.29c4-3.53 10.06-3.11 13.55.92l.54.62c3.49 4.04 3.08 10.17-.92 13.7z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-6",
  d: "M589.59 336.8l-48.05 42.41-13.17-15.24 48.05-42.41a9.599 9.599 0 0113.64.93l.46.53c3.51 4.06 3.1 10.23-.92 13.78zM615.88 367.34l-47.28 41.73-13.17-15.24 47.28-41.73a9.68 9.68 0 0113.76.94l.34.4c3.54 4.1 3.13 10.32-.93 13.9z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-6",
  d: "M595.05 405.79l-37.58 32.92-13.24-15.31 63.56-55.85-2.51 18.98a31.09 31.09 0 01-10.23 19.26zM599.67 340.61l.72.83c3.44 3.98 2.48 10.52-2.15 14.6l-46.19 40.77-13.17-15.24 46.19-40.77c4.63-4.08 11.17-4.17 14.61-.19z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-6",
  d: "M560.18 435.05l-42.26 73.81-52.64-55.85 43.69-77.19 51.21 59.23z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-4",
  d: "M547.54 457.12l-29.62 51.73-52.64-55.84 11-19.43s15.58-6.69 26.08 0c10.85 6.91 10.38 26.41 23.67 30.46 11.7 3.56 21.51-6.92 21.51-6.92zM573.38 352.24c-.31 0-.62-.13-.85-.38-.41-.47-.37-1.18.1-1.6l16.21-14.31c3.55-3.13 3.92-8.6.81-12.19l-.46-.53a8.411 8.411 0 00-5.86-2.93c-2.28-.15-4.46.6-6.18 2.11l-18.42 16.25c-.47.41-1.18.37-1.6-.1-.41-.47-.37-1.18.1-1.6l18.42-16.25c2.17-1.91 4.95-2.86 7.83-2.67 2.88.19 5.52 1.51 7.42 3.71l.46.53c3.91 4.52 3.45 11.42-1.03 15.37l-16.21 14.31c-.22.19-.48.28-.75.28z"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-4",
  d: "M584.18 369.58c-.31 0-.62-.13-.85-.38-.41-.47-.37-1.18.1-1.6l15.3-13.51c3.47-3.06 3.83-8.4.8-11.91l-.72-.83a8.24 8.24 0 00-5.72-2.86c-2.22-.16-4.36.58-6.04 2.06l-14.77 13.04c-.47.41-1.18.37-1.6-.1-.41-.47-.37-1.18.1-1.6l14.77-13.04c2.13-1.88 4.86-2.81 7.69-2.62 2.83.19 5.41 1.48 7.28 3.64l.72.83c3.84 4.44 3.38 11.21-1.01 15.09l-15.3 13.51c-.22.19-.48.28-.75.28zM514.94 350.09c-.31 0-.62-.13-.85-.38-.41-.47-.37-1.18.1-1.6l41.44-36.58c2.16-1.91 4.92-2.85 7.78-2.65 2.87.19 5.48 1.5 7.37 3.69l.54.62c3.89 4.5 3.43 11.35-1.02 15.28l-14.82 13.08c-.47.41-1.18.37-1.6-.1-.41-.47-.37-1.18.1-1.6l14.82-13.08c3.53-3.11 3.89-8.54.81-12.11l-.54-.62a8.357 8.357 0 00-5.81-2.91c-2.26-.16-4.43.59-6.13 2.1l-41.44 36.58c-.22.19-.48.28-.75.28z"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-4",
  d: "M518.14 510.74l-54.26-57.56 24.55-43.37 5.61-42.14c1.83-13.76 8.19-26.74 17.92-36.54.44-.44 1.16-.45 1.6 0 .44.44.45 1.16 0 1.6-9.38 9.46-15.52 21.98-17.28 35.25l-5.67 42.57-.11.19-23.83 42.11 51.02 54.13 39.93-69.74.14-.12 36.54-32.17c5.41-4.77 8.91-11.36 9.86-18.56l1.48-11.22 9.47-8.66c3.6-3.18 3.97-8.7.84-12.33l-.34-.4c-1.52-1.75-3.62-2.81-5.92-2.96-2.29-.15-4.51.6-6.24 2.13l-20.88 18.43c-.47.41-1.18.37-1.6-.1-.41-.47-.37-1.18.1-1.6l20.88-18.43c2.19-1.93 4.98-2.89 7.89-2.69 2.9.2 5.56 1.52 7.47 3.74l.34.4c3.94 4.56 3.48 11.51-1.04 15.49l-8.85 8.09-1.37 10.41a32.225 32.225 0 01-10.61 19.96l-36.4 32.04-41.26 72.06z"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-8",
  d: "M371.46 615.42l-18.51-12.7 114.83-170.88 82.39 56.53-71.45 106.33c-23.96 35.65-71.98 44.93-107.26 20.72z"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-4",
  d: "M369.29 578.63a1.13 1.13 0 01-.94-1.76l98.48-146.56c.17-.25.43-.42.73-.48s.6 0 .85.18l9.27 6.36c.52.35.65 1.06.29 1.57-.35.52-1.06.65-1.57.29l-8.33-5.72-97.85 145.62c-.22.32-.58.5-.94.5z"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-4",
  d: "M414.67 629.14c-15.54 0-30.72-4.68-43.86-13.69l-18.51-12.7c-.52-.35-.65-1.06-.29-1.57.35-.52 1.06-.65 1.57-.29l18.51 12.7c16.77 11.5 36.97 15.74 56.88 11.94 20.02-3.83 37.35-15.32 48.8-32.36l70.83-105.4-72.2-49.53c-.52-.35-.65-1.06-.29-1.57.35-.52 1.06-.65 1.57-.29l73.12 50.16c.51.35.64 1.05.3 1.56l-71.45 106.33c-11.79 17.54-29.63 29.37-50.25 33.31-4.91.94-9.84 1.4-14.73 1.4zM409.05 519.46a1.1 1.1 0 01-.64-.2l-89.21-61.2c-.52-.35-.65-1.06-.29-1.57.35-.52 1.06-.65 1.57-.29l89.21 61.2c.52.35.65 1.06.29 1.57-.22.32-.57.49-.93.49z"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-4",
  d: "M365.79 611.81c-.22 0-.45-.07-.64-.2l-114.87-79.17c-.51-.35-.64-1.06-.29-1.57.35-.51 1.06-.64 1.57-.29l114.87 79.17c.51.35.64 1.06.29 1.57-.22.32-.57.49-.93.49z"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-4",
  d: "M372.54 615.69l-121.62-83.04 120.53 96.19c35.28 24.21 79.74 18.65 103.69-17l.58-12.45c-24.18 29.77-68.15 40.33-103.19 16.29z"
});

var _ref38 = /*#__PURE__*/React.createElement("ellipse", {
  className: "fansi-video_svg__cls-4",
  cx: 411.78,
  cy: 316.91,
  rx: 25.01,
  ry: 24.97
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-4",
  d: "M341.29 262.76c-6.84 6.28-7.29 16.91-1 23.75 6.29 6.83 16.94 7.28 23.78 1s7.29-16.91 1-23.75c-6.29-6.83-16.94-7.28-23.78-1z"
});

var _ref40 = /*#__PURE__*/React.createElement("ellipse", {
  className: "fansi-video_svg__cls-4",
  cx: 338.12,
  cy: 333.91,
  rx: 23.44,
  ry: 23.41
});

var _ref41 = /*#__PURE__*/React.createElement("ellipse", {
  className: "fansi-video_svg__cls-4",
  cx: 383.18,
  cy: 296.93,
  rx: 28.21,
  ry: 28.17
});

var _ref42 = /*#__PURE__*/React.createElement("ellipse", {
  className: "fansi-video_svg__cls-4",
  cx: 331.13,
  cy: 291.88,
  rx: 22.78,
  ry: 22.75
});

var _ref43 = /*#__PURE__*/React.createElement("ellipse", {
  className: "fansi-video_svg__cls-4",
  cx: 356.99,
  cy: 304.73,
  rx: 25.01,
  ry: 24.97
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-6",
  d: "M350.5 421.47l27.61 74.26 12.99 8.91 6.09-139-44.16-1.93-2.53 57.76z"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-4",
  d: "M352.3 380.43l.73-16.72 44.17 1.92-1.61 36.91c-4.02.62-12.01 1.27-21-2.13-14.07-5.32-20.6-16.78-22.28-19.98z"
});

var _ref46 = /*#__PURE__*/React.createElement("ellipse", {
  className: "fansi-video_svg__cls-6",
  cx: 381.84,
  cy: 352.83,
  rx: 38.72,
  ry: 35.08,
  transform: "rotate(-87.46 381.828 352.833)"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-4",
  d: "M381.55 392.68c-.48 0-.97-.01-1.46-.03-11.2-.49-18.47-2.64-27.17-13.02-.4-.48-.34-1.19.14-1.59.48-.4 1.19-.34 1.59.14 8.2 9.79 14.77 11.74 25.53 12.21 18.66.84 34.66-15.36 35.57-36.07.44-10.05-2.69-19.65-8.81-27.03-6.09-7.35-14.43-11.61-23.47-12.01-11.99-.5-23.18 5.81-29.88 16.95-.32.53-1.02.71-1.55.39-.54-.32-.71-1.02-.39-1.55 7.03-11.68 19.27-18.6 31.92-18.04 9.69.42 18.6 4.98 25.11 12.82 6.48 7.81 9.79 17.96 9.33 28.57-.94 21.42-17.15 38.26-36.47 38.26z"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-4",
  d: "M383.54 314.15c-19.36-.85-38.6 13.88-39.54 35.25-.08 1.92 2.76 5.72 2.92 7.58l33.11-27.33 35.89 13.6c-3.61-16.16-16.5-28.39-32.38-29.09z"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-1",
  d: "M365.69 362.54c.48 3.88 2.14 7.65 5.06 10.7 6.5 6.79 16.85 7.65 24.35 2.46l-29.4-13.16z"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-video_svg__cls-2",
  d: "M546.05 556.72a1.136 1.136 0 01-.6-2.1l103.43-63.53c.53-.33 1.23-.16 1.56.37.33.53.16 1.23-.37 1.56l-103.43 63.53c-.18.11-.39.17-.59.17zM589.16 568.93a1.136 1.136 0 01-.6-2.1l123.3-75.74c.53-.33 1.23-.16 1.56.37.33.53.16 1.23-.37 1.56l-123.3 75.74c-.18.11-.39.17-.59.17zM584.96 610.2a1.136 1.136 0 01-.6-2.1l96.62-59.35c.53-.32 1.23-.16 1.56.37.33.53.16 1.23-.37 1.56l-96.62 59.35c-.18.11-.39.17-.59.17z"
});

function SvgFansiVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fansi-video_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 810.38 999.96",
    className: "w-full h-full"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50);
}

export default SvgFansiVideo;